export default __webpack_public_path__ + "static/media/sr-logo.1b2630e5.png";